var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.smallScreen?'py-0 px-0':'',attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{class:_vm.layout},[_vm._t("default")],2)],1),(_vm.bottomSpace)?_c('div',{style:(_vm.bottomSpaceStyle)}):_vm._e(),_vm._t("dialogs")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }